import { Routes, Route, Navigate, useNavigate, Outlet } from "react-router-dom";
import Home from "../pages/user/home/home";
import Introduce from "../pages/user/introduce/introduce";
import IntroduceOverview from "../pages/user/introduce/introduceOverview";
import IntroduceFoundationVision from "../pages/user/introduce/introduceFoundationVision";
import IntroducePolicies from "../pages/user/introduce/introducePolicies";
import IntroduceCulture from "../pages/user/introduce/introduceCulture";
import IntroducrOriented from "../pages/user/introduce/introducrOriented";
import IntroduceUpdating from "../pages/user/introduce/IntroduceUpdating";
import LeaderShip from "../pages/user/leaderShip/Leaders";
import LeaderMember from "../pages/user/leaderShip/LeaderMember";
import MemberContent from "../pages/user/leaderShip/MemberContent";
import "../pages/user/leaderShip/leaders.scss";
import TypicalProject from "../pages/user/typicalProject/TypicalProject";
import DetailTypicalProject from "../pages/user/typicalProject/DetailTypicalProject";
import News from "../pages/user/News/news";
import DetailNews from "../pages/user/News/DetailNews";
import CustomPageDetail from "../pages/user/customPage/CustomPageDetail";
import ProductSolution from "../pages/user/productSolution/ProductSolution";
import DetailPSCategory from "../pages/user/productSolution/DetailPSCategory";
import DetailPSContent from "../pages/user/productSolution/DetailPSContent";
import Contact from "../pages/user/contact/contact";
import Recruitment from "../pages/user/recruitment/recruiment";
import RecruimentContent from "../pages/user/recruitment/recruimentContent";
import ListCustomer from "../pages/user/customers/ListCustomer";
import LeaderOrganize from "../pages/user/leaderShip/LeaderOrganize";
import ConsultingServices from "../pages/user/ConsultingServices/ConsultingServices";
import EcosystemDetail from "../pages/user/ecosystem/EcosystemDetail";
import EsmGraphOverview from "../pages/user/ecosystem/EsmGraphOverview";
import EsmInteractionFlowPage from "../pages/user/ecosystem/EsmInteractionFlowPage";
import EsmPresentation from "../pages/user/ecosystem/EsmPresentation";
import Search from "../pages/user/search/search";
import PageNotFound from "../components/notfound/PageNotFound";
import RootRedirect from "../components/rootRedirect/RootRedirect";

import AdminLayout from "../layouts/AdminLayout";

// Admin pages
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminProfile from "../pages/admin/AdminProfile";

// Languages
import LanguagesList from "../pages/admin/languages/List";
import LanguagesForm from "../pages/admin/languages/Form";

// Nav Menus
import NavMenusList from "../pages/admin/nav-menus/List";
import NavMenusForm from "../pages/admin/nav-menus/Form";

// News Categories
import NewsCategoriesList from "../pages/admin/news-categories/List";
import NewsCategoriesForm from "../pages/admin/news-categories/Form";

// News
import NewsList from "../pages/admin/news/List";
import NewsForm from "../pages/admin/news/Form";

// Custom Pages
import CustomPagesList from "../pages/admin/custom-pages/List";
import CustomPagesForm from "../pages/admin/custom-pages/Form";

// Section Content Cards
import SectionContentCardsList from "../pages/admin/section-content-cards/List";
import SectionContentCardsForm from "../pages/admin/section-content-cards/Form";

// Consultings
import ConsultingsList from "../pages/admin/consultings/List";
import ConsultingsForm from "../pages/admin/consultings/Form";

// Recruitments
import RecruitmentsList from "../pages/admin/recruitments/List";
import RecruitmentsForm from "../pages/admin/recruitments/Form";
import RecruitmentApplicationsList from "../pages/admin/recruitment-applications/List";
import { RecruitmentDepartmentsForm, RecruitmentDepartmentsList } from "../pages/admin/recruitment-departments";

// Contacts
import ContactsList from "../pages/admin/contacts/List";
import ContactsForm from "../pages/admin/contacts/Form";

// Customers
import CustomersList from "../pages/admin/customers/List";
import CustomersForm from "../pages/admin/customers/Form";

// Customer Categories
import { CustomerCategoriesForm, CustomerCategoriesList } from "../pages/admin/customer-categories";

// Business Activity Categories & Activities
import { BusinessActivityCategoriesForm, BusinessActivityCategoriesList } from "../pages/admin/business-activity-categories";
import { BusinessActivitiesForm, BusinessActivitiesList } from "../pages/admin/business-activities";

// Leader Categories
import LeaderCategoriesList from "../pages/admin/leader-categories/List";
import LeaderCategoriesForm from "../pages/admin/leader-categories/Form";

// Leaders
import LeadersList from "../pages/admin/leaders/List";
import LeadersForm from "../pages/admin/leaders/Form";
import LeadersDetail from "../pages/admin/leaders/Detail";
import LeaderInformationItemsList from "../pages/admin/leader-information-items/List";
import LeaderInformationItemsForm from "../pages/admin/leader-information-items/Form";

// Organization Charts
import OrganizationChartsList from "../pages/admin/organization-charts/List";
import OrganizationChartsForm from "../pages/admin/organization-charts/Form";

// Typical Projects
import TypicalProjectsList from "../pages/admin/typical-projects/List";
import TypicalProjectsForm from "../pages/admin/typical-projects/Form";
import EcosystemGroupsList from "../pages/admin/ecosystem-groups/List";
import EcosystemGroupsForm from "../pages/admin/ecosystem-groups/Form";
import EcosystemServicesList from "../pages/admin/ecosystem-services/List";
import EcosystemServicesForm from "../pages/admin/ecosystem-services/Form";

// Project Information
import ProjectInformationTypesList from "../pages/admin/project-information-types/List";
import ProjectInformationTypesForm from "../pages/admin/project-information-types/Form";
import TypicalProjectInformationItemsList from "../pages/admin/typical-project-information-items/List";
import TypicalProjectInformationItemsForm from "../pages/admin/typical-project-information-items/Form";
import ProjectsInProgressInformationItemsList from "../pages/admin/projects-in-progress-information-items/List";
import ProjectsInProgressInformationItemsForm from "../pages/admin/projects-in-progress-information-items/Form";

// Introduce Menus
import IntroduceMenusList from "../pages/admin/introduce-menus/List";
import IntroduceMenusForm from "../pages/admin/introduce-menus/Form";

// Introduce Overviews
import IntroduceOverviewsList from "../pages/admin/introduce-overviews/List";
import IntroduceOverviewsForm from "../pages/admin/introduce-overviews/Form";

// Introduce Capacities
import IntroduceCapacitiesList from "../pages/admin/introduce-capacities/List";
import IntroduceCapacitiesForm from "../pages/admin/introduce-capacities/Form";

// Introduce Messages
import IntroduceMessagesList from "../pages/admin/introduce-messages/List";
import IntroduceMessagesForm from "../pages/admin/introduce-messages/Form";

// Introduce Foundationals
import IntroduceFoundationalsList from "../pages/admin/introduce-foundationals/List";
import IntroduceFoundationalsForm from "../pages/admin/introduce-foundationals/Form";

// Business Licenses
import BusinessLicensesList from "../pages/admin/business-licenses/List";
import BusinessLicensesForm from "../pages/admin/business-licenses/Form";
import AdminLogin from "../components/admin/AdminLogin";
import AdminForgotPassword from "../components/admin/AdminForgotPassword";
import AdminChangePassword from "../components/admin/AdminChangePassword";

// Product Solution Groups
import ProductSolutionGroupsList from "../pages/admin/product-solution-groups/List";
import ProductSolutionGroupsForm from "../pages/admin/product-solution-groups/Form";

// Product Solution Categories
import ProductSolutionCategoriesList from "../pages/admin/product-solution-categories/List";
import ProductSolutionCategoriesForm from "../pages/admin/product-solution-categories/Form";

// Home Banners
import HomeBannersList from "../pages/admin/home-banners/List";
import HomeBannersForm from "../pages/admin/home-banners/Form";

// Product Solution Contents
import ProductSolutionContentsList from "../pages/admin/product-solution-contents/List";
import ProductSolutionContentsForm from "../pages/admin/product-solution-contents/Form";

// Projects In Progress
import ProjectsInProgressList from "../pages/admin/projects-in-progress/List";
import ProjectsInProgressForm from "../pages/admin/projects-in-progress/Form";

// Introduce Visions
import IntroduceVisionsList from "../pages/admin/introduce-visions/List";
import IntroduceVisionsForm from "../pages/admin/introduce-visions/Form";

// Introduce Orientations
import IntroduceOrientationsList from "../pages/admin/introduce-orientations/List";
import IntroduceOrientationsForm from "../pages/admin/introduce-orientations/Form";

// Introduce Cultures
import IntroduceCulturesList from "../pages/admin/introduce-cultures/List";
import IntroduceCulturesForm from "../pages/admin/introduce-cultures/Form";

// Introduce Policies
import IntroducePoliciesList from "../pages/admin/introduce-policies/List";
import IntroducePoliciesForm from "../pages/admin/introduce-policies/Form";
import ShareholderDocuments from "../pages/user/shareholders/ShareholderDocuments";
import ShareholderDocumentsList from "../pages/admin/shareholder-documents/List";
import ShareholderDocumentsForm from "../pages/admin/shareholder-documents/Form";

import { UsersList, UsersForm } from "../pages/admin/users";

const isAuthenticated = () => {
  return !!localStorage.getItem("accessToken");
};

const getUserRole = () => {
  try {
    const user = JSON.parse(localStorage.getItem("adminUser") || "{}");
    return (user.role || user.RoleName || "").toLowerCase();
  } catch {
    return "";
  }
};

// Component bảo vệ route yêu cầu đăng nhập
const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/admin/auth/login" />;
};

// Component bảo vệ route chỉ dành riêng cho Admin
const AdminOnlyRoute = ({ children }) => {
  const role = getUserRole();
  return role === "admin" ? children : <Navigate to="/admin/dashboard" replace />;
};

function Router() {
  const navigate = useNavigate();

  const handleLogin = (token, user) => {
    localStorage.setItem("accessToken", token);
    if (user) {
      localStorage.setItem("adminUser", JSON.stringify(user));
    }
    navigate("/admin/dashboard", { replace: true });
  };

  return (
    <Routes>
      <Route
        path="/admin/auth/login"
        element={<AdminLogin onLogin={handleLogin} />}
      />
      <Route
        path="/admin/auth/forgot-password"
        element={<AdminForgotPassword />}
      />
      <Route
        path="/admin/auth/change-password"
        element={<AdminChangePassword />}
      />
      <Route path="/" element={<RootRedirect />} />
      <Route path="/trang-chu" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/search" element={<Search />} />

      {/* Giới thiệu - VI */}
      <Route path="/tong-quan/" element={<Introduce />}>
        <Route
          path="/tong-quan/"
          element={<Navigate to="/tong-quan/ban-lanh-dao/1" replace />}
        />
        <Route
          path="/tong-quan/tong-quan"
          element={<Navigate to="/tong-quan/ban-lanh-dao/1" replace />}
        />
        <Route
          path="/tong-quan/thong-diep"
          element={<Navigate to="/tong-quan/logo-gia-tri-nen-tang" replace />}
        />
        <Route
          path="/tong-quan/logo-gia-tri-nen-tang"
          element={<IntroduceFoundationVision />}
        />
        <Route
          path="/tong-quan/tam-nhin-su-menh-gia-tri-cot-loi"
          element={<Navigate to="/tong-quan/logo-gia-tri-nen-tang" replace />}
        />
        <Route
          path="/tong-quan/moc-thoi-gian"
          element={<IntroduceUpdating title="Mốc thời gian / Cột mốc chính" />}
        />
        <Route
          path="/tong-quan/ho-so-nang-luc"
          element={<IntroduceOverview showActivities={false} />}
        />
        <Route
          path="/tong-quan/cong-ty-thanh-phan"
          element={<Navigate to="/tong-quan/cong-ty-thanh-vien" replace />}
        />
        <Route
          path="/tong-quan/cong-ty-thanh-vien"
          element={<IntroduceUpdating title="Công ty thành viên" />}
        />
        <Route
          path="/tong-quan/thuong-hieu-doi-tac"
          element={<Navigate to="/tong-quan/khach-hang-doi-tac" replace />}
        />
        <Route
          path="/tong-quan/khach-hang-doi-tac"
          element={<ListCustomer />}
        />
        <Route
          path="/tong-quan/dinh-huong-phat-trien"
          element={<IntroducrOriented />}
        />
        <Route
          path="/tong-quan/van-hoa-va-moi-truong-lam-viec"
          element={<IntroduceCulture />}
        />
        <Route
          path="/tong-quan/chinh-sach-nhan-su"
          element={<IntroducePolicies />}
        />
      </Route>
      {/* Giới thiệu - EN */}
      <Route path="/about-us/" element={<Introduce />}>
        <Route
          path="/about-us/"
          element={<Navigate to="/about-us/leadership/1" replace />}
        />
        <Route
          path="/about-us/overview"
          element={<Navigate to="/about-us/leadership/1" replace />}
        />
        <Route
          path="/about-us/message"
          element={<Navigate to="/about-us/logo-foundational-values" replace />}
        />
        <Route
          path="/about-us/logo-foundational-values"
          element={<IntroduceFoundationVision />}
        />
        <Route
          path="/about-us/vision-mission-values-core"
          element={<Navigate to="/about-us/logo-foundational-values" replace />}
        />
        <Route
          path="/about-us/milestones"
          element={<IntroduceUpdating title="Milestones" language="en" />}
        />
        <Route
          path="/about-us/capability-profile"
          element={<IntroduceOverview showActivities={false} />}
        />
        <Route
          path="/about-us/member-companies"
          element={<IntroduceUpdating title="Member companies" language="en" />}
        />
        <Route
          path="/about-us/partners"
          element={<Navigate to="/about-us/customers-partners" replace />}
        />
        <Route path="/about-us/customers-partners" element={<ListCustomer />} />
        <Route
          path="/about-us/development-direction"
          element={<IntroducrOriented />}
        />
        <Route
          path="/about-us/culture-work-environment"
          element={<IntroduceCulture />}
        />
        <Route path="/about-us/hr-policies" element={<IntroducePolicies />} />
        
        {/* Fallbacks for when backend returns Vietnamese slugs in English mode */}
        <Route path="/about-us/tong-quan" element={<Navigate to="/about-us/leadership/1" replace />} />
        <Route path="/about-us/ban-lanh-dao" element={<Navigate to="/about-us/leadership/1" replace />} />
        <Route path="/about-us/thong-diep" element={<Navigate to="/about-us/logo-foundational-values" replace />} />
        <Route path="/about-us/logo-gia-tri-nen-tang" element={<Navigate to="/about-us/logo-foundational-values" replace />} />
        <Route path="/about-us/tam-nhin-su-menh-gia-tri-cot-loi" element={<Navigate to="/about-us/logo-foundational-values" replace />} />
        <Route path="/about-us/moc-thoi-gian" element={<Navigate to="/about-us/milestones" replace />} />
        <Route path="/about-us/ho-so-nang-luc" element={<Navigate to="/about-us/capability-profile" replace />} />
        <Route path="/about-us/cong-ty-thanh-vien" element={<Navigate to="/about-us/member-companies" replace />} />
        <Route path="/about-us/thuong-hieu-doi-tac" element={<Navigate to="/about-us/customers-partners" replace />} />
        <Route path="/about-us/khach-hang-doi-tac" element={<Navigate to="/about-us/customers-partners" replace />} />
        <Route path="/about-us/dinh-huong-phat-trien" element={<Navigate to="/about-us/development-direction" replace />} />
      </Route>
      
      {/* Giới thiệu - EN (Overview Alias) */}
      <Route path="/overview/" element={<Introduce />}>
        <Route path="/overview/" element={<Navigate to="/overview/leadership/1" replace />} />
        <Route path="/overview/overview" element={<Navigate to="/overview/leadership/1" replace />} />
        <Route path="/overview/message" element={<Navigate to="/overview/logo-foundational-values" replace />} />
        <Route path="/overview/logo-foundational-values" element={<IntroduceFoundationVision />} />
        <Route path="/overview/vision-mission-values-core" element={<Navigate to="/overview/logo-foundational-values" replace />} />
        <Route path="/overview/milestones" element={<IntroduceUpdating title="Milestones" language="en" />} />
        <Route path="/overview/capability-profile" element={<IntroduceOverview showActivities={false} />} />
        <Route path="/overview/member-companies" element={<IntroduceUpdating title="Member companies" language="en" />} />
        <Route path="/overview/partners" element={<Navigate to="/overview/customers-partners" replace />} />
        <Route path="/overview/customers-partners" element={<ListCustomer />} />
        <Route path="/overview/development-direction" element={<IntroducrOriented />} />
        <Route path="/overview/culture-work-environment" element={<IntroduceCulture />} />
        <Route path="/overview/hr-policies" element={<IntroducePolicies />} />
        
        {/* Fallbacks for when backend returns Vietnamese slugs in English mode */}
        <Route path="/overview/tong-quan" element={<Navigate to="/overview/leadership/1" replace />} />
        <Route path="/overview/ban-lanh-dao" element={<Navigate to="/overview/leadership/1" replace />} />
        <Route path="/overview/thong-diep" element={<Navigate to="/overview/logo-foundational-values" replace />} />
        <Route path="/overview/logo-gia-tri-nen-tang" element={<Navigate to="/overview/logo-foundational-values" replace />} />
        <Route path="/overview/tam-nhin-su-menh-gia-tri-cot-loi" element={<Navigate to="/overview/logo-foundational-values" replace />} />
        <Route path="/overview/moc-thoi-gian" element={<Navigate to="/overview/milestones" replace />} />
        <Route path="/overview/ho-so-nang-luc" element={<Navigate to="/overview/capability-profile" replace />} />
        <Route path="/overview/cong-ty-thanh-vien" element={<Navigate to="/overview/member-companies" replace />} />
        <Route path="/overview/thuong-hieu-doi-tac" element={<Navigate to="/overview/customers-partners" replace />} />
        <Route path="/overview/khach-hang-doi-tac" element={<Navigate to="/overview/customers-partners" replace />} />
        <Route path="/overview/dinh-huong-phat-trien" element={<Navigate to="/overview/development-direction" replace />} />
      </Route>
      {/* Ban lãnh đạo - VI (Hỗ trợ cả /tong-quan/ban-lanh-dao và /gioi-thieu/ban-lanh-dao) */}
      <Route path="/tong-quan/ban-lanh-dao" element={<LeaderShip />}>
        <Route path="so-do-to-chuc" element={<LeaderOrganize />} />
        <Route path=":slug" element={<LeaderMember />} />
      </Route>
      <Route path="/gioi-thieu/ban-lanh-dao" element={<LeaderShip />}>
        <Route path="so-do-to-chuc" element={<LeaderOrganize />} />
        <Route path=":slug" element={<LeaderMember />} />
      </Route>
      {/* Ban lãnh đạo - EN */}
      <Route path="/about-us/leadership" element={<LeaderShip />}>
        <Route path="organization-chart" element={<LeaderOrganize />} />
        <Route path=":slug" element={<LeaderMember />} />
      </Route>
      <Route path="/overview/leadership" element={<LeaderShip />}>
        <Route path="organization-chart" element={<LeaderOrganize />} />
        <Route path=":slug" element={<LeaderMember />} />
      </Route>
      {/* Chi tiết Ban lãnh đạo */}
      <Route
        path="/tong-quan/ban-lanh-dao/:categorySlug/:slug"
        element={<MemberContent />}
      />
      <Route
        path="/gioi-thieu/ban-lanh-dao/:categorySlug/:slug"
        element={<MemberContent />}
      />
      <Route
        path="/about-us/leadership/:categorySlug/:slug"
        element={<MemberContent />}
      />
      <Route
        path="/overview/leadership/:categorySlug/:slug"
        element={<MemberContent />}
      />
      {/* Redirect từ URL cũ */}
      <Route
        path="/khach-hang-doi-tac"
        element={<Navigate to="/tong-quan/khach-hang-doi-tac" replace />}
      />
      <Route
        path="/khach-hang-doi-tac/:slug"
        element={<Navigate to="/tong-quan/khach-hang-doi-tac" replace />}
      />
      <Route
        path="/gioi-thieu/khach-hang-doi-tac"
        element={<Navigate to="/tong-quan/khach-hang-doi-tac" replace />}
      />
      <Route
        path="/customers-partners"
        element={<Navigate to="/about-us/customers-partners" replace />}
      />
      <Route
        path="/customers-partners/:slug"
        element={<Navigate to="/about-us/customers-partners" replace />}
      />

      {/* Dự án - VI */}
      <Route path="/du-an-tieu-bieu" element={<TypicalProject />} />
      <Route path="/du-an-tieu-bieu/:id" element={<DetailTypicalProject />} />
      {/* Dự án - EN */}
      <Route path="/typical-projects" element={<TypicalProject />} />
      <Route path="/typical-projects/:id" element={<DetailTypicalProject />} />

      {/* Tin tức - VI */}
      <Route path="/tin-tuc" element={<News />} />
      <Route path="/tin-tuc/:slug" element={<DetailNews />} />
      {/* Tin tức - EN */}
      <Route path="/news" element={<News />} />
      <Route path="/news/:slug" element={<DetailNews />} />

      {/* Trang tùy chỉnh / Chính sách - VI & EN */}
      <Route path="/trang/:slug" element={<CustomPageDetail />} />
      <Route path="/page/:slug" element={<CustomPageDetail />} />
      <Route path="/en/page/:slug" element={<CustomPageDetail />} />
      <Route path="/chinh-sach/:slug" element={<CustomPageDetail />} />

      {/* Sản phẩm giải pháp - VI */}
      <Route path="/san-pham-giai-phap/" element={<ProductSolution />} />
      <Route
        path="/san-pham-giai-phap/:categoryID"
        element={<DetailPSCategory />}
      />
      <Route
        path="/san-pham-giai-phap/:categoryID/:slug"
        element={<DetailPSContent />}
      />
      {/* Sản phẩm giải pháp - EN */}
      <Route path="/products-solutions/" element={<ProductSolution />} />
      <Route
        path="/products-solutions/:categoryID"
        element={<DetailPSCategory />}
      />
      <Route
        path="/products-solutions/:categoryID/:slug"
        element={<DetailPSContent />}
      />

      {/* Đầu tư dịch vụ - VI */}
      <Route path="/dau-tu-dich-vu" element={<ConsultingServices />} />
      <Route
        path="/dau-tu-dich-vu/:categoryID"
        element={<ConsultingServices />}
      />
      {/* Đầu tư dịch vụ - EN */}
      <Route path="/investment-services" element={<ConsultingServices />} />
      <Route
        path="/investment-services/:categoryID"
        element={<ConsultingServices />}
      />

      {/* Hệ sinh thái - nội dung được phân nhóm theo 7 hệ sinh thái trong database */}
      <Route path="/he-sinh-thai/:slug" element={<EcosystemDetail />} />
      <Route path="/ecosystem/:slug" element={<EcosystemDetail />} />

      {/* Trang HSV Corp & HSV Thương Mại */}
      <Route path="/hsvcorp" element={<EcosystemDetail />} />
      <Route path="/hsv-corp" element={<EcosystemDetail />} />
      <Route path="/hsv-thuong-mai" element={<EcosystemDetail />} />
      <Route path="/hsv-commercial" element={<EcosystemDetail />} />

      {/* Trang Graph Hệ Sinh Thái ESM */}
      <Route path="/he-sinh-thai-esm" element={<EsmGraphOverview />} />
      <Route path="/esm-ecosystem" element={<EsmGraphOverview />} />
      <Route path="/tuong-tac-esm" element={<EsmInteractionFlowPage />} />
      <Route path="/esm-interaction" element={<EsmInteractionFlowPage />} />
      <Route path="/ecosystem-smart-medic" element={<EsmPresentation />} />

      {/* Liên hệ - VI */}
      <Route path="/lien-he/" element={<Contact />} />
      {/* Liên hệ - EN */}
      <Route path="/contact/" element={<Contact />} />

      <Route
        path="/tuyen-dung"
        element={<Navigate to="/tuyen-dung/cong-viec-tuyen-dung" replace />}
      />
      <Route
        path="/tuyen-dung/van-hoa-va-moi-truong-lam-viec"
        element={<IntroduceCulture />}
      />
      <Route
        path="/tuyen-dung/chinh-sach-nhan-su"
        element={<IntroducePolicies />}
      />
      <Route
        path="/tuyen-dung/cong-viec-tuyen-dung"
        element={<Recruitment />}
      />
      <Route
        path="/tuyen-dung/cong-viec-tuyen-dung/:slug"
        element={<RecruimentContent />}
      />
      <Route path="/tuyen-dung/:slug" element={<RecruimentContent />} />

      <Route
        path="/recruitment"
        element={<Navigate to="/recruitment/career-opportunities" replace />}
      />
      <Route
        path="/recruitment/culture-work-environment"
        element={<IntroduceCulture />}
      />
      <Route path="/recruitment/hr-policies" element={<IntroducePolicies />} />
      <Route
        path="/recruitment/career-opportunities"
        element={<Recruitment />}
      />
      <Route
        path="/recruitment/career-opportunities/:slug"
        element={<RecruimentContent />}
      />
      <Route path="/recruitment/:slug" element={<RecruimentContent />} />
      <Route path="/co-dong/hoi-dong-co-dong" element={<LeaderShip />}>
        <Route path=":slug" element={<LeaderMember />} />
      </Route>
      <Route path="/shareholders/shareholder-council" element={<LeaderShip />}>
        <Route path=":slug" element={<LeaderMember />} />
      </Route>
      <Route path="/co-dong/:section?" element={<ShareholderDocuments />} />
      <Route
        path="/shareholders/:section?"
        element={<ShareholderDocuments />}
      />
      {/* Dynamic Custom Pages under sections */}
      <Route path="/tong-quan/:slug" element={<CustomPageDetail />} />
      <Route path="/gioi-thieu/:slug" element={<CustomPageDetail />} />
      <Route path="/about-us/:slug" element={<CustomPageDetail />} />
      <Route path="/overview/:slug" element={<CustomPageDetail />} />
      <Route path="/co-dong/:slug" element={<CustomPageDetail />} />
      <Route path="/shareholders/:slug" element={<CustomPageDetail />} />

      {/* Dynamic Custom Pages - direct slug from admin without /trang prefix */}
      <Route path="/:slug" element={<CustomPageDetail />} />
      <Route path="/:parentSlug/:slug" element={<CustomPageDetail />} />

      {/* Fallback routes with /trang or /page prefix */}
      <Route path="/trang/:slug" element={<CustomPageDetail />} />
      <Route path="/page/:slug" element={<CustomPageDetail />} />

      <Route path="*" element={<PageNotFound />} />

      {/* ── ADMIN ROUTES ──────────────────────────────────────── */}
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      >
        <Route path="dashboard" index element={<AdminDashboard />} />
        <Route path="profile" element={<AdminProfile />} />

        {/* Users (Admin Only) */}
        <Route path="users" element={<AdminOnlyRoute><Outlet /></AdminOnlyRoute>}>
          <Route index element={<UsersList />} />
          <Route path="create" element={<UsersForm />} />
          <Route path="edit/:id" element={<UsersForm />} />
        </Route>

        {/* Languages */}
        <Route path="languages">
          <Route index element={<LanguagesList />} />
          <Route path="create" element={<LanguagesForm />} />
          <Route path="edit/:id" element={<LanguagesForm />} />
        </Route>

        {/* Nav Menus */}
        <Route path="nav-menus">
          <Route index element={<NavMenusList />} />
          <Route path="create" element={<NavMenusForm />} />
          <Route path="edit/:id" element={<NavMenusForm />} />
        </Route>

        {/* News Categories */}
        <Route path="news-categories">
          <Route index element={<NewsCategoriesList />} />
          <Route path="create" element={<NewsCategoriesForm />} />
          <Route path="edit/:id" element={<NewsCategoriesForm />} />
        </Route>

        {/* News */}
        <Route path="news">
          <Route index element={<NewsList />} />
          <Route path="create" element={<NewsForm />} />
          <Route path="edit/:id" element={<NewsForm />} />
        </Route>

        {/* Custom Pages */}
        <Route path="custom-pages">
          <Route index element={<CustomPagesList />} />
          <Route path="create" element={<CustomPagesForm />} />
          <Route path="edit/:id" element={<CustomPagesForm />} />
        </Route>

        {/* Section Content Cards */}
        <Route path="section-content-cards">
          <Route index element={<SectionContentCardsList />} />
          <Route path="create" element={<SectionContentCardsForm />} />
          <Route path="edit/:id" element={<SectionContentCardsForm />} />
        </Route>

        {/* Consultings */}
        <Route path="consultings">
          <Route index element={<ConsultingsList />} />
          <Route path="create" element={<ConsultingsForm />} />
          <Route path="edit/:id" element={<ConsultingsForm />} />
        </Route>

        {/* Recruitments */}
        <Route path="recruitments">
          <Route index element={<RecruitmentsList />} />
          <Route path="create" element={<RecruitmentsForm />} />
          <Route path="edit/:id" element={<RecruitmentsForm />} />
        </Route>

        {/* Recruitment Departments */}
        <Route path="recruitment-departments">
          <Route index element={<RecruitmentDepartmentsList />} />
          <Route path="create" element={<RecruitmentDepartmentsForm />} />
          <Route path="edit/:id" element={<RecruitmentDepartmentsForm />} />
        </Route>

        {/* Recruitment Applications */}
        <Route path="recruitment-applications" element={<RecruitmentApplicationsList />} />

        {/* Contacts */}
        <Route path="contacts">
          <Route index element={<ContactsList />} />
          <Route path="create" element={<ContactsForm />} />
          <Route path="edit/:id" element={<ContactsForm />} />
        </Route>

        {/* Customers */}
        <Route path="customers">
          <Route index element={<CustomersList />} />
          <Route path="create" element={<CustomersForm />} />
          <Route path="edit/:id" element={<CustomersForm />} />
        </Route>

        {/* Customer Categories */}
        <Route path="customer-categories">
          <Route index element={<CustomerCategoriesList />} />
          <Route path="create" element={<CustomerCategoriesForm />} />
          <Route path="edit/:id" element={<CustomerCategoriesForm />} />
        </Route>

        {/* Business Activity Categories */}
        <Route path="business-activity-categories">
          <Route index element={<BusinessActivityCategoriesList />} />
          <Route path="create" element={<BusinessActivityCategoriesForm />} />
          <Route path="edit/:id" element={<BusinessActivityCategoriesForm />} />
        </Route>

        {/* Business Activities */}
        <Route path="business-activities">
          <Route index element={<BusinessActivitiesList />} />
          <Route path="create" element={<BusinessActivitiesForm />} />
          <Route path="edit/:id" element={<BusinessActivitiesForm />} />
        </Route>

        {/* Leader Categories */}
        <Route path="leader-categories">
          <Route index element={<LeaderCategoriesList />} />
          <Route path="create" element={<LeaderCategoriesForm />} />
          <Route path="edit/:id" element={<LeaderCategoriesForm />} />
        </Route>

        {/* Leaders */}
        <Route path="leaders">
          <Route index element={<LeadersList />} />
          <Route path="create" element={<LeadersForm />} />
          <Route path="view/:id" element={<LeadersDetail />} />
          <Route path="edit/:id" element={<LeadersForm />} />
        </Route>

        <Route path="leader-information-items">
          <Route index element={<LeaderInformationItemsList />} />
          <Route path="create" element={<LeaderInformationItemsForm />} />
          <Route path="edit/:id" element={<LeaderInformationItemsForm />} />
        </Route>

        {/* Organization Charts */}
        <Route path="organization-charts">
          <Route index element={<OrganizationChartsList />} />
          <Route path="create" element={<OrganizationChartsForm />} />
          <Route path="edit/:id" element={<OrganizationChartsForm />} />
        </Route>

        {/* Typical Projects */}
        <Route path="typical-projects">
          <Route index element={<TypicalProjectsList />} />
          <Route path="create" element={<TypicalProjectsForm />} />
          <Route path="edit/:id" element={<TypicalProjectsForm />} />
        </Route>

        <Route path="ecosystem-groups">
          <Route index element={<EcosystemGroupsList />} />
          <Route path="create" element={<EcosystemGroupsForm />} />
          <Route path="edit/:id" element={<EcosystemGroupsForm />} />
        </Route>

        <Route path="ecosystem-services">
          <Route index element={<EcosystemServicesList />} />
          <Route path="create" element={<EcosystemServicesForm />} />
          <Route path="edit/:id" element={<EcosystemServicesForm />} />
        </Route>

        {/* Project Information Types */}
        <Route path="project-information-types">
          <Route index element={<ProjectInformationTypesList />} />
          <Route path="create" element={<ProjectInformationTypesForm />} />
          <Route path="edit/:id" element={<ProjectInformationTypesForm />} />
        </Route>

        {/* Typical Project Information Items */}
        <Route path="typical-project-information-items">
          <Route index element={<TypicalProjectInformationItemsList />} />
          <Route
            path="create"
            element={<TypicalProjectInformationItemsForm />}
          />
          <Route
            path="edit/:id"
            element={<TypicalProjectInformationItemsForm />}
          />
        </Route>

        {/* Projects In Progress Information Items */}
        <Route path="projects-in-progress-information-items">
          <Route index element={<ProjectsInProgressInformationItemsList />} />
          <Route
            path="create"
            element={<ProjectsInProgressInformationItemsForm />}
          />
          <Route
            path="edit/:id"
            element={<ProjectsInProgressInformationItemsForm />}
          />
        </Route>

        {/* Introduce Menus */}
        <Route path="introduce-menus">
          <Route index element={<IntroduceMenusList />} />
          <Route path="create" element={<IntroduceMenusForm />} />
          <Route path="edit/:id" element={<IntroduceMenusForm />} />
        </Route>

        {/* Introduce Overviews */}
        <Route path="introduce-overviews">
          <Route index element={<IntroduceOverviewsList />} />
          <Route path="create" element={<IntroduceOverviewsForm />} />
          <Route path="edit/:id" element={<IntroduceOverviewsForm />} />
        </Route>

        {/* Introduce Capacities */}
        <Route path="introduce-capacities">
          <Route index element={<IntroduceCapacitiesList />} />
          <Route path="create" element={<IntroduceCapacitiesForm />} />
          <Route path="edit/:id" element={<IntroduceCapacitiesForm />} />
        </Route>

        {/* Introduce Messages */}
        <Route path="introduce-messages">
          <Route index element={<IntroduceMessagesList />} />
          <Route path="create" element={<IntroduceMessagesForm />} />
          <Route path="edit/:id" element={<IntroduceMessagesForm />} />
        </Route>

        {/* Introduce Foundationals */}
        <Route path="introduce-foundationals">
          <Route index element={<IntroduceFoundationalsList />} />
          <Route path="create" element={<IntroduceFoundationalsForm />} />
          <Route path="edit/:id" element={<IntroduceFoundationalsForm />} />
        </Route>

        {/* Business Licenses */}
        <Route path="business-licenses">
          <Route index element={<BusinessLicensesList />} />
          <Route path="create" element={<BusinessLicensesForm />} />
          <Route path="edit/:id" element={<BusinessLicensesForm />} />
        </Route>

        {/* Product Solution Groups */}
        <Route path="product-solution-groups">
          <Route index element={<ProductSolutionGroupsList />} />
          <Route path="create" element={<ProductSolutionGroupsForm />} />
          <Route path="edit/:id" element={<ProductSolutionGroupsForm />} />
        </Route>

        {/* Product Solution Categories */}
        <Route path="product-solution-categories">
          <Route index element={<ProductSolutionCategoriesList />} />
          <Route path="create" element={<ProductSolutionCategoriesForm />} />
          <Route path="edit/:id" element={<ProductSolutionCategoriesForm />} />
        </Route>

        {/* Home Banners */}
        <Route path="home-banners">
          <Route index element={<HomeBannersList />} />
          <Route path="create" element={<HomeBannersForm />} />
          <Route path="edit/:id" element={<HomeBannersForm />} />
        </Route>

        {/* Product Solution Contents */}
        <Route path="product-solution-contents">
          <Route index element={<ProductSolutionContentsList />} />
          <Route path="create" element={<ProductSolutionContentsForm />} />
          <Route path="edit/:id" element={<ProductSolutionContentsForm />} />
        </Route>

        {/* Projects In Progress */}
        <Route path="projects-in-progress">
          <Route index element={<ProjectsInProgressList />} />
          <Route path="create" element={<ProjectsInProgressForm />} />
          <Route path="edit/:id" element={<ProjectsInProgressForm />} />
        </Route>

        {/* Introduce Visions */}
        <Route path="introduce-visions">
          <Route index element={<IntroduceVisionsList />} />
          <Route path="create" element={<IntroduceVisionsForm />} />
          <Route path="edit/:id" element={<IntroduceVisionsForm />} />
        </Route>

        {/* Introduce Orientations */}
        <Route path="introduce-orientations">
          <Route index element={<IntroduceOrientationsList />} />
          <Route path="create" element={<IntroduceOrientationsForm />} />
          <Route path="edit/:id" element={<IntroduceOrientationsForm />} />
        </Route>

        {/* Introduce Cultures */}
        <Route path="introduce-cultures">
          <Route index element={<IntroduceCulturesList />} />
          <Route path="create" element={<IntroduceCulturesForm />} />
          <Route path="edit/:id" element={<IntroduceCulturesForm />} />
        </Route>

        {/* Introduce Policies */}
        <Route path="introduce-policies">
          <Route index element={<IntroducePoliciesList />} />
          <Route path="create" element={<IntroducePoliciesForm />} />
          <Route path="edit/:id" element={<IntroducePoliciesForm />} />
        </Route>
        <Route path="shareholder-documents">
          <Route index element={<ShareholderDocumentsList />} />
          <Route path="create" element={<ShareholderDocumentsForm />} />
          <Route path="edit/:id" element={<ShareholderDocumentsForm />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default Router;
